import _ from "lodash"

export const invitationSelector = token => state => {
  return _.get(state.invitationByToken, token, {})
}
